import * as React from "react";
import Link from "gatsby-link";
import Helmet from "react-helmet";

import "./styles.scss";
import Header from "../components/Header";
import ThemeContext from "../context/ThemeContext";

if (typeof window !== "undefined") {
  const WebFont = require("webfontloader");
  const WebFontConfig = {
    custom: {
      families: ['ahamonoregular'],
    }
  };
  
  WebFont.load({
    custom: {
      families: ['ahamonoregular']
    }
  });
}

const TemplateWrapper = ({ children }: any) => (
  <ThemeContext>
    <main>
      <Header />
      {children()}
    </main>
  </ThemeContext>
);

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.tsx